export const ToLogout = () => {
  sessionStorage.clear();
  window.location.href = (import.meta.env.VITE_APP_BASE_SERVER_URL || 'http://localhost:3000') + '/auth/logout';
};
